<div class="fd-accreditation-not-found" [fxFlex.md]="50" [fxFlex.lg]="75">
  <div class="fd-accreditation-not-found__title">
    <h4>CREDENCIAMENTO - ADMIN</h4>
    <img class="fd-accreditation-not-found__fiserv-logo" src="assets/img/fiserv-logo.png">
  </div>
   <fa-icon [icon]="icons.faExclamationTriangle" class="fd-accreditation-not-found__warning-icon" size="3x"></fa-icon>
   <h1>Url Inválida</h1>
</div>
